import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { changePasswordRequest, changePasswordRequestError, changePasswordRequestSuccess } from "../../slices/Profile/ChangePasswordSlice";

export const ChangePasswordApi =
    (data) => async (dispatch) => {
        try {
            dispatch(changePasswordRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.changePassword,
                data: data,
                headers: { "Content-Type": "application/json" },
            })
            return dispatch(changePasswordRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(changePasswordRequestError(_error));
        }
    };
